import React from 'react';

import { useLocation } from 'react-router-dom';

import { ExpiredActivationLink } from '../ExpiredActivationLink';
import { ExpiredPasswordLink } from '../ExpiredPasswordLink';

export const ExpiredLinkWrapper: React.FC = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const page = searchParams.get('page');
  const activationStatus = searchParams.get('activationStatus');
  if (page === 'change-password' && activationStatus === `ACTIVE`) {
    return <ExpiredPasswordLink />;
  }

  return <ExpiredActivationLink />;
};
